import React from 'react';
import RequestCreationTable from '@components/RequestCreationTable';

type Props = {};

const RequestCreationScreen = (props: Props) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <RequestCreationTable />
    </div>
  );
};

export default RequestCreationScreen;
